
import PageHeader from "../components/PageHeader";
import GalleryDetail from "../components/GalleryDetail";
import DayLinks from "./DayLinks";

export default function Gallery() {
	return (
		<>
			<PageHeader title="छायाचित्रदर्शन" path="/gallery" name="Gallery" />
			<DayLinks />
			<GalleryDetail />
		</>
	);
}